module.exports = __webpack_public_path__ + "static/media/pull-request.4a6821dc.svg";